import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=224b4f50&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=224b4f50&prod&lang=scss&scoped=true"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=224b4f50&prod&lang=scss"
import style2 from "./DashboardLayout.vue?vue&type=style&index=2&id=224b4f50&prod&lang=css"
import style3 from "./DashboardLayout.vue?vue&type=style&index=3&id=224b4f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b4f50",
  null
  
)

export default component.exports